import React, {Component} from "react"
import ProgressiveImage from "react-progressive-image-loading";
import {withTranslate} from "react-redux-multilingual"
import Rating from "react-rating";
import {connect} from "react-redux";
import globalMiddleware from "../../hocs/globalMiddleware";
import {clearOfferDetails, getOfferDetails} from "../../store/actions/offerActions";
import {clearError500, setCurrentRoute} from "../../store/actions/globalActions"
import {Link, withRouter} from "react-router-dom";
import {setOfferDetailsSkeleton, setShareIconsSkeleton} from "../../skeleton"
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
} from 'react-share';
import NoMatch from "../NoMatch";
import Maintenance from "../../components/doctors/DoctorsPage";

class OfferDetails extends Component {

    componentWillReceiveProps(nextProps, nextContext) {
        this.discount = nextProps.offerDetails ? (nextProps.offerDetails.price / nextProps.offerDetails.old_price) * 100 : null;
    }

    componentDidMount() {
        this.props.clearError500();
        this.props.clearOfferDetails();
        this.props.getOfferDetails(this.props.match.params.id);
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);

    }

    /* showTitle = (offer) => {
         let copyOfferTitle = document.getElementById("copy-offer-title" + offer.id);
         copyOfferTitle.style.display = "block";
     };
     hideTitle = (offer) => {
         let copyOfferTitle = document.getElementById("copy-offer-title" + offer.id);
         copyOfferTitle.style.display = "none";
     };*/
    /* copiedLink = () => {
         this.setState({copied: true});
         showToast(this.props.translate('offer_link_copied_successfulley'), "green")
     };*/
    cacheOfferData = (offer, e) => {
        window.localStorage.setItem("offer", JSON.stringify(offer));
    };

    render() {

        const {offerDetails, offerDetailsIsLoading, offerIdNotFound, error500} = this.props;

        if (error500) {
            return (
                <Maintenance/>
            )
        }
        if (offerIdNotFound) {
            return <NoMatch/>
        }
        return (
            <div id="offer-details" className="mobile-menu-m-t-big">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {
                                !offerDetailsIsLoading ?
                                    <div>
                                        <div className="offer-details-box">
                                            {/*offer image*/}
                                            <div className="offer-image">
                                                <ProgressiveImage
                                                    style={{boxShadow: '1px 0 10px #cecdcd'}}
                                                    preview="/images/offer-details-placeholder.png"
                                                    src={offerDetails.image}
                                                    render={(src, style) => <img alt="head" src={src}
                                                                                 style={{boxShadow: '1px 0 10px #cecdcd'}}/>}
                                                />
                                                {
                                                    this.discount && this.discount !== "UNDEFINED" && offerDetails ?
                                                        <p className="discount-off">{Math.floor(this.discount) + " " + "%" + " " +this.props.translate('off')}</p>
                                                        : null
                                                }
                                            </div>

                                            <div className="offer-info">
                                                <div>
                                                    <div className="offer-info-name">
                                                        <span
                                                            className={offerDetails.is_featured === 1 ? "offer-featured capitalized" : "capitalized"}>{offerDetails.is_featured === 1 ? this.props.translate('ad') : ""}</span>

                                                        <span className="offer-name mb-0">{offerDetails.name}</span>

                                                    </div>
                                                    <div className="offer-booked-details">
                                                        <div className="offer-booked">
                                                            <p className="name">
                                                                {/*<img className="icon" src="/images/doctor-name.png" alt=""/>*/}
                                                                {offerDetails.users_booked + " " + this.props.translate('users_booked')}
                                                            </p>
                                                            <p className="expired capitalized">
                                                                {offerDetails.expiry_date === 0 ?
                                                                    this.props.translate('expires_today')
                                                                    : this.props.translate('expires_on') + " " + offerDetails.expiry_date + " " + this.props.translate('days')}
                                                            </p>
                                                        </div>
                                                        <div className="offer-discount">
                                                            <strike>{offerDetails.old_price + " " + this.props.translate("currency")}</strike>
                                                            <div className="full-width">
                                                                <p className="bolder font-15">{offerDetails.price + " " + this.props.translate("currency")}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="offer-desc">
                                                        <p>{offerDetails.desc}</p>
                                                        {offerDetails.reservation_fees_included === 1 ?
                                                            <div className="offer-fees-included">
                                                                <i className="fas fa-info-circle"></i>
                                                                <p>
                                                                    {this.props.translate('fees_included')}
                                                                </p>
                                                            </div> : ""}
                                                    </div>

                                                    <div className="offer-option">
                                                        {!offerDetailsIsLoading ?
                                                            <div className="share-area flex flex-direction-row">
                                                                <FacebookShareButton
                                                                    url={window.location.origin + "/offer/" + offerDetails.id}>
                                                                    <FacebookIcon size={32} round/>
                                                                </FacebookShareButton>
                                                                <LinkedinShareButton
                                                                    url={window.location.origin + "/offer/" + offerDetails.id}>
                                                                    <LinkedinIcon size={32} round/>
                                                                </LinkedinShareButton>
                                                                <TwitterShareButton
                                                                    url={window.location.origin + "/offer/" + offerDetails.id}>
                                                                    <TwitterIcon size={32} round/>
                                                                </TwitterShareButton>
                                                                <WhatsappShareButton
                                                                    url={window.location.origin + "/offer/" + offerDetails.id}>
                                                                    <WhatsappIcon size={32} round/>
                                                                </WhatsappShareButton>
                                                            </div> :
                                                            <div className="share-area-skeleton">
                                                                {setShareIconsSkeleton(4)}
                                                            </div>
                                                        }
                                                    </div>

                                                </div>


                                            </div>


                                            {/*<div className="offer-doc-details">
                                                <div className="offer-doc-info">
                                                    <img className="offer-avatar"
                                                         src={offerDetails.doctor.image} alt="profile"/>
                                                    <div className="doc-name-rate">
                                                        <p className="offer-doctor-name">{offerDetails.doctor_name}</p>
                                                        <Rating
                                                            initialRating={offerDetails.doctor.rate}
                                                            readonly
                                                            emptySymbol="fa fa-star-o font-20 empty-star"
                                                            fullSymbol="fa fa-star font-20 full-star"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="offer-option width-percentage-50">
                                                    <div className="share-area">
                                                        <FacebookShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <FacebookIcon size={32} round/>
                                                        </FacebookShareButton>
                                                        <LinkedinShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <LinkedinIcon size={32} round/>
                                                        </LinkedinShareButton>
                                                        <TwitterShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <TwitterIcon size={32} round/>
                                                        </TwitterShareButton>
                                                        <WhatsappShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <WhatsappIcon size={32} round/>
                                                        </WhatsappShareButton>
                                                    </div>
                                                </div>
                                            </div>*/}
                                        </div>


                                        <div className="btn-book-offer-sticky">
                                            <div className="container">
                                                <div className="offer-doc-details">
                                                    <a href={"/doctor/" + offerDetails.doctor.unique_id}>
                                                        <div className="offer-doc-info">
                                                            <img className="offer-avatar"
                                                                 src={offerDetails.doctor.image} alt="profile"/>
                                                            <div className="doc-name-rate">
                                                                <p className="offer-doctor-name">{offerDetails.doctor_name}</p>
                                                                <Rating
                                                                    direction={this.props.language === 'ar' ? "rtl" : "ltr"}
                                                                    initialRating={offerDetails.doctor.rate}
                                                                    readonly
                                                                    emptySymbol="fa fa-star-o font-20 empty-star"
                                                                    fullSymbol="fa fa-star font-20 full-star"
                                                                />
                                                            </div>
                                                        </div>
                                                    </a>
                                                    {/* <div className="offer-option width-percentage-50">
                                                    <div className="share-area">
                                                        <FacebookShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <FacebookIcon size={32} round/>
                                                        </FacebookShareButton>
                                                        <LinkedinShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <LinkedinIcon size={32} round/>
                                                        </LinkedinShareButton>
                                                        <TwitterShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <TwitterIcon size={32} round/>
                                                        </TwitterShareButton>
                                                        <WhatsappShareButton
                                                            url={window.location.origin + "/offer/" + offerDetails.id}>
                                                            <WhatsappIcon size={32} round/>
                                                        </WhatsappShareButton>
                                                    </div>
                                                </div>*/}


                                                    <div className="book-offer-area">
                                                        <div className="offer-discount">
                                                            <p className="bolder">{offerDetails.price + " " + this.props.translate("currency")}</p>
                                                        </div>
                                                        <Link to={"/doctor/" + offerDetails.doctor.unique_id}
                                                              onClick={(e) => this.cacheOfferData(offerDetails, e)}>{this.props.translate("book")}</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : setOfferDetailsSkeleton()}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
};
const mapStateToProps = (state) => {
    return {
        offerDetails: state.offer.offerDetails,
        offerDetailsIsLoading: state.offer.offerDetailsIsLoading,
        offerIdNotFound: state.offer.offerIdNotFound,
        route: state.global.route,
        error500: state.global.error500,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOfferDetails: (offer_id) => dispatch(getOfferDetails(offer_id)),
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        clearOfferDetails: () => dispatch(clearOfferDetails()),
        clearError500: () => dispatch(clearError500())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(withRouter(OfferDetails))))

